import set from 'lodash/set';
import get from 'lodash/get';

export const setConvertData = (state, { convertData, path }) => {
  if (path) {
    set(state.convertData, path, convertData);
  } else {
    state.convertData = convertData;
  }
};

export const addSection = (state, { payload, parent }) => {
  if (!parent) {
    state.convertData.push(payload);
  } else {
    set(state.convertData, parent, [...get(state.convertData, parent), payload]);
  }
};

export const setRemovePlaceholders = (state, payload) => {
  state.removeInstanceFields = payload;
}

export const addElement = (state, { payload, parent }) => {
  if (!parent) {
    state.convertData.push(payload);
  } else {
    set(state.convertData, parent, [...get(state.convertData, parent), payload]);
  }
};

export const setRemoveInstanceFields = (state, payload) => {
  state.removeInstanceFields = payload;
}

export const addInstanceField = (state, payload) => {
  state.instanceFields.push(payload);
}

export const setType = (state, payload) => {
  state.type = payload;
}

export const setOptions = (state, payload) => {
  state.options = payload;
}

export const setCurrentSelection = (
  state, path) => state.currentSelection = path;

export const setParentStyles = (state, payload) => {
  state.parentStyles = payload;
}

export const sortBlock = (
  state, { oldIndex, newIndex, oldItem, newItem, parent }) => {
  const locationHasChange = parent ?
    get(state.convertData, parent) :
    state.convertData;

  locationHasChange.splice(oldIndex, 1, newItem);
  locationHasChange.splice(newIndex, 1, oldItem);
};

export const updateSettingsWithPath = (state, { key, value, path }) => {
  let currentSelection = get(state.convertData, path);

  set(currentSelection, key, value);
};

export const updateSettings = (state, { key, value }) => {
  let currentSelection = get(state.convertData, state.currentSelection);

  set(currentSelection, key, value);
};

export const removeComponent = (state, path) => {
  const regex = new RegExp('^[0-9\\[\\]]+$', 'g');

  if (regex.test(path)) {
    const index = path.replaceAll(/[^\d]/g, '');

    state.convertData.splice(index, 1);
  } else {
    console.log('children');
  }
  // console.log(path.replace(/\[[0-9]+\]$/g, ''));
  // remove(state.convertData.replace(/\[[0-9]+\]$/g, ''), path);
};

export const setGlobalStyles = (state, payload) => {
  state.globalStyles = payload;
}